const getters = {
  cmd: state => state.cmd,
  cmdTemplateData: state => state.cmd_template_data,
  cmdSmsData: state => state.cmd_sms_data,
  cmdGprsData: state => state.cmd_gprs_data,
  cmdScheduleData: state => state.cmd_schedule_data
}

export default getters
